module.exports = __webpack_public_path__ + "img/responsive-lazy.6998a0e7.jpg";